// src/components/ProtectedRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, requireAuth = true }) => {
  const { isAuthenticated, user, loading, checkDashboardAccess } = useAuth();

  // Show loading state
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-8 w-8 border-4 border-solid border-purple-600 border-r-transparent"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }
    // Determine which dashboard we're trying to access based on the path
    const path = window.location.pathname;
  // Check if authentication is required
  if (requireAuth) {
    if (!isAuthenticated) {
      const returnUrl = encodeURIComponent(path + window.location.search);
      if(path.startsWith('/editors')){
        return <Navigate to={`/editors/login?returnUrl=${returnUrl}`} replace />;
      }
      return <Navigate to={`/portal/login?returnUrl=${returnUrl}`} replace />;
    }


    
    // Check if user has permission for the current route
    if (path.startsWith('/editors') && !checkDashboardAccess('admin')) {
      // Try to redirect to an available dashboard
      if (user?.canAccessAuthor) return <Navigate to="/dashboard" replace />;
      if (user?.canAccessReviewer) return <Navigate to="/reviewerdash" replace />;
      return <Navigate to="/editors/dashboard" replace />;
    }
    
    if (path.startsWith('/reviewerdash') && !checkDashboardAccess('reviewer')) {
      if (user?.canAccessAuthor) return <Navigate to="/dashboard" replace />;
      if (user?.canAccessEditor) return <Navigate to="/editors/dashboard" replace />;
      return <Navigate to="/portal/login" replace />;
    }
    
    if ((path === '/' || path.startsWith('/dashboard') || path.startsWith('/manuscripts') || 
         path.startsWith('/coauthored') || path.startsWith('/inreview') || path.startsWith('/submit') || 
         path.startsWith('/reviews')) && !checkDashboardAccess('author')) {
      if (user?.canAccessReviewer) return <Navigate to="/reviewerdash" replace />;
      if (user?.canAccessEditor) return <Navigate to="/editors/dashboard" replace />;

      return <Navigate to="/portal/login" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;